// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"45a994c1","540":"26829982"}[chunkId] + ".chunk.css";
};